import 'cirrus-ui'
import { NavigationContext } from '../contexts/NavigationContext'

export function NavigationButton() {

    return (
        <NavigationContext.Consumer>
            {
                (value) => {
                    return (
                        <div className={value.isToggleOn ? 'nav-item nav-btn active' : 'nav-item nav-btn'} id='header-btn' onClick={() => value.setToggleOn(!value.isToggleOn)}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    )
                }
            }

        </NavigationContext.Consumer>
    )

}


